export default "__VITE_ASSET__BApSXkN9__"